import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "../component css/about_beyond_section.css";
import img1 from "../assets/images/about/beyond_section images/drawing.jpeg";
import img2 from "../assets/images/about/beyond_section images/robotics_award.jpeg";
import img3 from "../assets/images/about/beyond_section images/tattoos.jpeg";
import img4 from "../assets/images/about/beyond_section images/VK_bot.jpeg";

const images = [
  { src: img1, label: "Drawing",   path: "/about/drawing" },
  { src: img2, label: "Robotics",  path: "/about/robotics" },
  { src: img3, label: "Tattooing", path: "/about/tattooing" },
  { src: img4, label: "Robotics",  path: "/about/robotics" },
];

export default function ImageOrbitCarousel() {
  const [activeIndex, setActiveIndex] = useState(2);
  const total = images.length;

  const getWrappedIndex = (index) => (index + total) % total;

  const nextSlide = () => {
    setActiveIndex((prev) => getWrappedIndex(prev + 1));
  };

  const prevSlide = () => {
    setActiveIndex((prev) => getWrappedIndex(prev - 1));
  };

  const positionedSlides = useMemo(() => {
    return images.map((item, index) => {
      let offset = index - activeIndex;

      if (offset > total / 2) offset -= total;
      if (offset < -total / 2) offset += total;

      return { ...item, index, offset };
    });
  }, [activeIndex, total]);

  const getSlideStyle = (offset) => {
    switch (offset) {
      case 0:
        return {
          transform: "translateX(0px) scale(1)",
          opacity: 1,
          zIndex: 30,
          filter: "blur(0px) brightness(1)",
        };

      case -1:
        return {
          transform: "translateX(-205px) scale(0.84)",
          opacity: 0.62,
          zIndex: 20,
          filter: "blur(0.8px) brightness(0.58)",
        };

      case 1:
        return {
          transform: "translateX(205px) scale(0.84)",
          opacity: 0.62,
          zIndex: 20,
          filter: "blur(0.8px) brightness(0.58)",
        };

      case -2:
        return {
          transform: "translateX(-330px) scale(0.7)",
          opacity: 0.34,
          zIndex: 10,
          filter: "blur(1.8px) brightness(0.42)",
        };

      case 2:
        return {
          transform: "translateX(330px) scale(0.7)",
          opacity: 0.34,
          zIndex: 10,
          filter: "blur(1.8px) brightness(0.42)",
        };

      default:
        return {
          transform: "translateX(0px) scale(0.6)",
          opacity: 0,
          zIndex: 0,
          filter: "blur(3px) brightness(0.3)",
        };
    }
  };

  return (
    <section className="orbit-carousel-section">
      <div className="orbit-carousel-header">
        <span className="orbit-title__label">Lifestyle &amp; Passions</span>
        <h2 className="orbit-title">Beyond The <span>Screen</span></h2>
        <p className="orbit-title__sub">From tattooing to robotics, explore the passions that live beyond the code.</p>
      </div>

      <div className="orbit-carousel-shell">
        <button
          className="orbit-nav orbit-nav-left"
          onClick={prevSlide}
          aria-label="Previous slide"
          type="button"
        >
          ‹
        </button>

        <div className="orbit-carousel">
          {positionedSlides.map(({ src, label, path, index, offset }) => {
            const absOffset = Math.abs(offset);
            const isActive = offset === 0;

            if (absOffset > 2) return null;

            return (
              <div
                key={index}
                className={`orbit-slide ${isActive ? "active" : ""}`}
                style={getSlideStyle(offset)}
                onClick={() => {
                  if (!isActive) setActiveIndex(index);
                }}
              >
                {isActive ? (
                  <Link to={path} className="orbit-image-wrap orbit-image-link">
                    <img src={src} alt={label} width="1600" height="1600" />
                    <span className="orbit-slide-label">Explore {label} ↗</span>
                  </Link>
                ) : (
                  <div className="orbit-image-wrap">
                    <img src={src} alt={label} width="1600" height="1600" />
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <button
          className="orbit-nav orbit-nav-right"
          onClick={nextSlide}
          aria-label="Next slide"
          type="button"
        >
          ›
        </button>
      </div>

    </section>
  );
}